"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _ComponentRemainingLifeElement = require("./ComponentRemainingLifeElement.legacy");
var _ComponentRemainingLifeElement2 = require("./ComponentRemainingLifeElement.modern");
// Flag-gated UI: `ComponentRemainingLifeElement.legacy` is the component as it
// is on master, `ComponentRemainingLifeElement.modern` the card from the
// ui-charts-update design. The nearest UiDesignProvider decides which renders.
var ComponentRemainingLifeElement = exports.ComponentRemainingLifeElement = (0, _uiSwitch.uiSwitch)(_ComponentRemainingLifeElement.ComponentRemainingLifeElement, _ComponentRemainingLifeElement2.ComponentRemainingLifeElement, "ComponentRemainingLifeElement");